import { setBatReport } from "../set/setBatReport";
import { graphQLFetch } from "../../../utils";
import { GENERATE_BAT_REPORT } from "../../queries";

export const getBatReport =
  ({ companyId, projectId }) =>
  async (dispatch, getState) => {
    if (!companyId || !projectId) {
      throw new Error("companyId and projectId are required to fetch BAT report");
    }

    const data = await graphQLFetch(
      GENERATE_BAT_REPORT,
      { cId: companyId, pId: projectId },
      "query",
      getState
    );

     const { generateBatReport } = data || {};
      if (!generateBatReport || !generateBatReport.base64) {
        console.error("Invalid PDF response:", data);
        throw new Error("Failed to generate BAT report");
      }

    const reportPayload = {
      base64: generateBatReport.base64,
      fileName: generateBatReport.fileName,
      mimeType: generateBatReport.mimeType,
    };

    return dispatch(setBatReport(reportPayload));
  };